import { createFileRoute, useRouter } from '@tanstack/react-router';
import { RouteErrorBoundary } from '@/components/shared/RouteErrorBoundary';
import { OperationsPage } from '@/features/operator/operations-page';

/**
 * Rule CR2: the first of "each top-level feature route" — the model every
 * future page under `_app` copies. Scoped to this route only (rule CR5), so
 * a crash here never costs the `_app` layout's own sidebar and header (rule
 * CR2's "leaves the navigation sidebar, the top bar ... intact"), which a
 * boundary declared only on `_app` itself could not guarantee on its own.
 */
function OperationsErrorBoundary({ error }: { error: unknown }) {
  const router = useRouter();
  return (
    <RouteErrorBoundary
      error={error}
      boundary="operations"
      onRetry={() => void router.invalidate()}
    />
  );
}

/** The operator app's only page: العمليات (fuel.md section 4). */
export const Route = createFileRoute('/_app/')({
  component: OperationsPage,
  errorComponent: OperationsErrorBoundary,
});
